<div class="lw-container" #graph>
  @if (loading) {
    <lds-progress-spinner></lds-progress-spinner>
  }
  <canvas id="averageTemp">{{graph}}</canvas>
</div>
